
import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import ISubmittingTicketDto from '@core/mappers/tickets/dtos/ISubmittingTicketDto';
import LottoBetSlipItemMapper from '@core/mappers/tickets/LottoBetSlipItemMapper';
import ILottoBetSlipDTO from '@core/models/lottoBetSlip/ILottoBetSlipDto';

const lottoBetSlipItemMapper = new LottoBetSlipItemMapper();
export default class LottoBetSlipToTicketDTOMapper extends AbstractMapper<ILottoBetSlipDTO, ISubmittingTicketDto> {

    createTargetObject(origin: ILottoBetSlipDTO) {
        const e = {} as Partial<ISubmittingTicketDto>;
        e.ticketOnline = origin.purchaseType;
        e.total = origin.stake;
        e.combs = origin.systems
                    .filter((system) => system.isSelected)
                    .map((system) => `${system.id}/${origin.selections.length}`);

        e.items = [lottoBetSlipItemMapper.map(origin)];
        e.clientSourceType = 'desktop';
        return e as ISubmittingTicketDto;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/tickets/LottoBetSlipToTicketDTOMapper.ts